import React from 'react';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
import EFCalculatorIcon2 from '@/components/UI/svg/Icons/EFCalculatorIcon2';
const { EFPic } = createEFPic('/media/delta2/pc/');
import { Input, Space, Form } from 'antd-v5';
import css from './index.module.scss';
import { powerMatchingEfficiency } from '@/constants/calculatorModule';

interface CalculatorInputProps {
    width?: number;
    getBatteryLife?: (life: any) => void;
}

export default function CalculatorInput({ width, getBatteryLife }: CalculatorInputProps) {
    const { useLang, Link, useRouter, useState, isMobile, useEffect } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta2portablepowerstation');
    const [validateStatus, setValidateStatus] = useState('');
    const [batteryLife, setBatteryLife] = useState('0');
    const [form] = Form.useForm();

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target?.value) {
            const newValue = e.target?.value.replace(/\D/g, '');
            if (newValue) {
                const wattValue = parseInt(newValue).toString();
                form.setFieldsValue({
                    wattage: wattValue,
                });
                if (Number(wattValue) > 1800) {
                    setValidateStatus('error');
                } else {
                    setValidateStatus('');
                }
                const efficiency = powerMatchingEfficiency(Number(wattValue));
                const batteryLife = (1024 * ((efficiency as number) * 10000)) / Number(wattValue) / 10000;
                if (batteryLife) {
                    setBatteryLife(batteryLife.toFixed(1));
                    getBatteryLife && getBatteryLife(batteryLife.toFixed(1));
                } else {
                    setBatteryLife(0);
                    getBatteryLife && getBatteryLife(0);
                }
            } else {
                form.setFieldsValue({
                    wattage: 0,
                });
                setValidateStatus('');
                setBatteryLife(0);
                getBatteryLife && getBatteryLife(0);
            }
        } else {
            form.setFieldsValue({
                wattage: 0,
            });
            setValidateStatus('');
            setBatteryLife(0);
            getBatteryLife && getBatteryLife(0);
        }
    };

    useEffect(() => {
        form.setFieldsValue({
            wattage: 0,
        });
    }, []);

    return (
        <div className={`${isMobile ? css.calculatorInputH5 : css.calculatorInput} calculatorInput`}>
            <div className="container">
                <div className="calculator-content">
                    <Form form={form}>
                        <Form.Item help={validateStatus === 'error' ? t('delta2.calculator_input_error') : ''} validateStatus={validateStatus}>
                            <Space.Compact>
                                <EFCalculatorIcon2 />
                                <Form.Item noStyle name="wattage">
                                    <Input className="input-box" suffix="W" onChange={handleChange}></Input>
                                </Form.Item>
                            </Space.Compact>
                        </Form.Item>
                    </Form>
                </div>
                <div className="hrs">{batteryLife}Hrs</div>
                <div className="tips">{t('delta2.calculator_input_tips')}</div>
            </div>
        </div>
    );
}
